import styled from 'styled-components/macro'
import palette from 'src/designSystem/variables/palette'
import { DerivedTextInput } from '../../Inputs'

export const AdvancedSearchFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${palette.neutral[100]};
  border-radius: 16px;
  width: 741px;
`

export const AdvancedSearchFormBody = styled.div`
  padding: 20px;
`

export const ExactMatchField = styled(DerivedTextInput)`
  margin-bottom: 0;
`

export const IncludeAnyField = styled(DerivedTextInput)`
  margin-bottom: 0;
`

export const IncludeAllField = styled(DerivedTextInput)`
  margin-bottom: 0;
`

export const ExcludeAllField = styled(DerivedTextInput)`
  margin-bottom: 0;
`

export const TitleContainer = styled.div`
  padding: 16px;
  font-size: 16px;
  font-weight: 500;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const AdvancedSearchButtonRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
`
